import {CanActivateFn, Router, UrlTree} from '@angular/router';
import {inject} from "@angular/core";
import { AuthHttpService } from '../../lib/auth-http.service';
import {catchError, map, of} from 'rxjs';

export const isAuthenticatedGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthHttpService);
  const router = inject(Router);
  const loginUrlTree: UrlTree = router.parseUrl('/auth');
  return authService.getMe().pipe(
    map(() => {
      const url = route.url.toString();
      if (url.includes('auth')) {
        return router.parseUrl('/console');
      }
      return true;
    }),
    catchError(() => of(loginUrlTree))
  )
};
